module.exports = __webpack_public_path__ + "static/media/FooterBlueBorder.f6b94d23.svg";